var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "url(#pattern0_708_32)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_708_32",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_708_32",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_708_32",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAABpklEQVR4nO2bMU7DAAxF30R6B3pEaG8JZAKOgtLdCCkDC5vVfKP3pMx9/rJdqalBRERERERERER+OAFXYAVuQDU9N+ANuADLYJ8WzsBnYzH1x/Oxf9Y0nxZOdyqqfhW3DPJp43rHomp/ngf5tLEeUNjrIJ82tgMK2wb5tFEHPVN82kgrrMJ8DBqDxo4eMKoV5uPqwKCxoweMaoX5uDowaOzoAaNaYT6uDgwaO3rAqFaYj6sDg8aOHjCqFebj6mBY0Ee8Ovoa5NNG2svQNcynjcsBhT0N8mlj2f9Ecq+i3oGHQT6tnO9U3DvwONCnlWX/x85r8xfSBrzs4/kw2EdERERkGGk3I6cwnxbSbkbOYT4tpN2MnMJ82ki7GbmG+bSR9rPkGubTRtrNyBbm00Yd9EzxaSOtsArzMWgMGjt6wKhWmI+rA4PGjh4wqhXm4+rAoLGjB4xqhfm4OjBo7OgBo1phPq4ODBo7esCoVpiPq4NhQafdjGxhPm2kvQxdw3zaSLsZuYT5tJF2M7KE+bSSdjNyDvNpJe1mZAnzERERERERERHhv/INZieFOEckHcIAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSout);
export default __webpack_public_path__ + "static/media/sout.dd0eddb7ccb337471d527aa1586bdada.svg";
export { ForwardRef as ReactComponent };